'use client';

import { Box, Tabs, Select, MenuItem } from '@/primitives';
import { useMediaQuery, Theme } from '@mui/material';
import { theme } from '@/lib/theme';
import { slate } from '@/lib/colours';

interface Tab {
  label: string;
  value: string;
}

interface SearchTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (value: string) => void;
}

export default function SearchTabs({
  tabs,
  activeTab,
  onTabChange,
}: SearchTabsProps) {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );

  if (isMobile) {
    return (
      <Box sx={{ px: 2, py: isMobile ? 1 : 2 }}>
        <Select
          value={activeTab}
          onChange={(e) => onTabChange(e.target.value as string)}
          fullWidth
        >
          {tabs.map((tab) => (
            <MenuItem key={tab.value} value={tab.value}>
              {tab.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 2 }}>
      <Tabs
        tabs={tabs}
        value={activeTab}
        onClick={(value) => onTabChange(value as string)}
        tabButtonProps={{
          sx: {
            borderRadius: 0,
            padding: '16px 20px',
            backgroundColor: 'transparent',
            ':hover': {
              backgroundColor: slate[100],
            },
            '&.selectedTab': {
              borderBottom: '4px solid',
              color: theme.palette.primary.dark,
            },
          },
        }}
      />
    </Box>
  );
}
